import { Instance, Table } from '@siposdani87/sui-js';
import { app } from '../app';
import { AdminCountryService } from '@services/adminCountryService';
import { LanguageService } from '@services/languageService';
import { initTable } from '@utils/collectionSetup';
import { AdminController } from './adminController';

export class AdminCountriesIndexController extends AdminController {
    static readonly inject = [
        'instances',
        'adminCountryService',
        'languageService',
    ] as const;

    private table!: Table;

    constructor(
        instances: Instance,
        private adminCountryService: AdminCountryService,
        private languageService: LanguageService,
    ) {
        super(instances);
    }

    protected override _initToolbarButtons(): void {
        this.helper.iconButton('.btn-admin-index', this.dom, () => {
            this.state.goBack('admin.index');
        });
    }

    protected override _initTable(): void {
        this.table = initTable(
            this.table,
            this.dom,
            'table',
            this.adminCountryService,
            {
                entityKey: 'countries',
                fetchData: (params) =>
                    this.adminCountryService.getAll(params),
                extraParams: (params) => {
                    params.set('query', this.query);
                },
            },
            [
                {
                    style: () => {
                        return [
                            'edit',
                            this.languageService.translate('buttons.edit'),
                        ];
                    },
                    click: (country) => {
                        this.adminCountryService
                            .editDialog(country, '/admin/')
                            .then(() => {
                                this._drawContent();
                            });
                    },
                },
            ],
        )!;
    }
}

export const adminCountriesIndexController = app.controller(
    'adminCountriesIndexController',
    AdminCountriesIndexController,
);
